"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const tsGoThemeVars_1 = require("../../../material-ui-theme/tsGoThemeVars");
const usePortal_1 = __importDefault(require("../../../utils/usePortal"));
const zustandStore_1 = require("../../../zustandStore");
const PageSpinner = ({ isLoading = false }) => {
    const spinner = ((0, jsx_runtime_1.jsx)("div", { "data-testid": "page-spinner", style: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,.71)',
            color: tsGoThemeVars_1.goPalette.tsGoColor.white,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
        }, children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, { color: "inherit" }) }));
    const isPageLoading = (0, zustandStore_1.useZustand)(state => state.pageSpinner.isLoading);
    const portalContent = (0, usePortal_1.default)('go-app-container', spinner);
    return Boolean(isLoading) || isPageLoading ? portalContent : null;
};
exports.default = PageSpinner;
